import React from "react";
import { toast } from "react-toastify";

export const useCloseMeeting = (isAdminOrCM, wsRef, handleLogs) => {
  /**
   * Sends a close_meeting message to the signaling server.
   * Only the host should be able to trigger this successfully on the backend.
   */
  const handleCloseMeeting = React.useCallback(() => {
    // if (!isAdminOrCM) {
    //   toast.error("You cannot end meeting only host can.");
    //   return;
    // }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: "close_meeting" }));
      handleLogs("Closing meeting (global)...");
    } else {
      toast.error("Not connected to signaling server", {
        autoClose: 2000,
        toastId: "signaling_server_error_close_meeting",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminOrCM]);

  return { handleCloseMeeting };
};
